var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dialog",
    _vm._g(
      _vm._b(
        { attrs: { title: _vm.locale.eventRules } },
        "Dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("div", { staticClass: "ff--common" }, [
        _c("div", { attrs: { "data-level": "1" } }, [_vm._v("1. Event Time")]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      This event will start on 2023/07/21 at 00:00 UTC+0 and end on 2023/08/21\n      at 00:00 UTC+0.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "1" } }, [
          _vm._v("2. Event Details"),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v("2.1 Participating in the Event"),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v(
            '\n      i. Eligibility: This event is only open to Rise of Kingdoms (hereinafter\n      referred to as "the game" or "RoK") players in certain countries or\n      regions (please refer to the "List of Countries/Regions for This Event"\n      at the end of this announcement). This event is open to players who\n      register both before and after the event starts (hereinafter referred to\n      as "you").\n    '
          ),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v("ii. Participation Method:"),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      1. Choose the civilization you wish to support, tap “Join,” and submit\n      your email address and UID on the event page. Your participation will be\n      deemed valid after completing verification with the verification code\n      sent to your in-game mailbox.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      2. After choosing your civilization, you will receive a free\n      scratchcard. Scratch the card for a chance to win a prize. You can win\n      additional scratchcards by completing event quests.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      3. After making your choice, your ID will be included in the list of\n      supporters of your chosen civilization and your in-game power will be\n      recorded. When the event ends, you will be ranked among all\n      participating players by how much power you have increased. If the\n      civilization you support ranks in the top three in terms of total power\n      increase, you will be eligible to draw a prize from the Civilization\n      Pool and stand a chance to win a Civilization Pool Grand Prize. In\n      addition, we will give additional rewards to the players with the\n      highest individual power increase in each of the top three\n      civilizations.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v("2.2 Prize Rules"),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v("i. Civilization Pool Grand Prizes:"),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      1. To calculate a civilization’s total power increase, we will add up\n      the power increase of all participating players who are supporting that\n      civilization. For example, the total power increase of Egypt will be the\n      sum of the power increase of all participating players who chose to\n      support Egypt.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      2. All supporters of the top three civilizations will get to draw a\n      prize.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "5" } }, [
          _vm._v(
            "\n      One randomly-chosen supporter of the 1st place civilization will win an\n      "
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://www.apple.com/apple-vision-pro/AppleVisionPro",
              },
            },
            [_vm._v("Apple Vision Pro")]
          ),
          _vm._v(".\n    "),
        ]),
        _c("div", { attrs: { "data-level": "5" } }, [
          _vm._v(
            "\n      One randomly-chosen supporter of the 2nd place civilization will win a\n      Sony PlayStation 5.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "5" } }, [
          _vm._v(
            "\n      One randomly-chosen supporter of the 3rd place civilization will win a\n      Nintendo Switch OLED.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      3. The Grand Prize winners will be chosen at random. Players\n      participating in this event will abide by the official prize draw rules\n      and accept the subsequent draw results. If you have any questions,\n      please submit your feedback during the announcement phase.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v("ii. Individual Rewards:"),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      1. The supporters of the top three civilizations with the highest\n      individual power increases will win additional rewards.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "5" } }, [
          _vm._v(
            "\n      The player with the highest power increase in the 1st place civilization\n      will win an Apple Vision Pro.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "5" } }, [
          _vm._v(
            "\n      The player with the highest power increase in the 2nd place civilization\n      will win a Sony PlayStation 5.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "5" } }, [
          _vm._v(
            "\n      The player with the highest power increase in the 3rd place civilization\n      will win a Nintendo Switch OLED.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      2. Your individual power will be based on the account tied to the UID\n      you used to sign up for the event.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v("iii. Scratchcard Rewards:"),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      1. You can earn scratchcards by selecting a civilization to support and\n      by completing event quests.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      2. You can scratch up to 5 cards per day. Once you’ve scratched 30\n      cards, you are guaranteed to win an Amazon gift card. After your 30th\n      scratchcard, you will not receive another guaranteed Amazon gift card if\n      scratch another 30 cards, but you will have a 1% chance to win another\n      gift card with every subsequent scratchcard.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v(
            "\n      iv. Participation Rewards: Enter the gift code in-game to get 20 Silver\n      Keys.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v(
            "\n      *Rankings will be updated at 04:00 UTC+0 on the following day.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v(
            "\n      *Winners will be displayed on the event page for 10 business days. If\n      you have any questions regarding the event, please reach out to us\n      during the announcement phase at\n      "
          ),
          _c("a", { attrs: { href: "mailto:overseas.marketing@lilith.com" } }, [
            _vm._v("overseas.marketing@lilith.com"),
          ]),
          _vm._v(
            ". After the announcement phase ends, we will stop receiving player\n      feedback.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v("2.3 How to Collect Prizes"),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v("i. Physical Prizes:"),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      1. If you win a physical prize, we will contact you via in-game mail.\n      The account we send the message to will be the account you used to sign\n      up for the event. You must submit your shipping address and other\n      required information within 7 days of receiving our message. If you fail\n      to do so, your prize will be forfeit.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      2. After your information has been confirmed, we will ship your prize to\n      you. The shipping method and logistics provider used will depend on your\n      shipping address. The delivery time may vary depending on your location\n      and other circumstances.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      3. Note: For the winner of the Apple Vision Pro, we will ship the prize\n      to you within six months after the product is released in your country\n      or region. The specific release time and availability in different\n      regions are subject to Apple. If the prize cannot be shipped to your\n      country or region, we will contact you again.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "3" } }, [
          _vm._v("ii. Virtual Prizes"),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      1. Amazon Gift Cards: We will send you a redemption code via in-game\n      mail. The account we send the message to will be the account you used to\n      sign up for the event. To redeem your gift card, visit the Amazon\n      website.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "4" } }, [
          _vm._v(
            "\n      2. Bundles: Enter the gift code provided to you in-game.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "1" } }, [
          _vm._v("3. Important Notes"),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      a. We will utilize third-party services to verify the validity of\n      participating users. Therefore, please refrain from cheating by using\n      multiple devices. Doing so may result in disqualification from the\n      event.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      b. If you are an iOS user, you will receive a pop-up asking for\n      permission to track your activity. Tracking is required for us to\n      identify you as a participant.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "1" } }, [
          _vm._v(
            "\n      4. By participating in this event, you agree to accept all the terms and\n      conditions of the event.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      a. We have no direct relationship with Apple, Sony, Nintendo, Amazon,\n      etc., and this event is in no way sponsored by any of the aforementioned\n      brands.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      b. Any fraudulent activity, such as using multiple devices to\n      artificially increase activity, will result in disqualification from the\n      event.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      c. The personal information you provide in this event, including but not\n      limited to your UID, email address, real name, shipping information, and\n      residential address, will be used for the management of this event and\n      to verify any prizes you win. Please note that if you win a physical\n      prize, we may need to provide some information to the logistics company\n      to verify your identity and ensure proper delivery. We will only share\n      information that is necessary for shipping with the logistics companies\n      and require them to handle your information in accordance with our\n      privacy policy and applicable laws. We fully understand the importance\n      of protecting user privacy. We are committed to handling your personal\n      information in a responsible and transparent manner. If you have any\n      questions about our privacy practices or use of information, please\n      contact us at any time.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      d. We reserve the right to modify or cancel the event at any time.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      e. By participating in this event, you agree to release us from any and\n      all liability related to the event.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      f. We reserve the right to final explanation of this event.\n    "
          ),
        ]),
        _c("div", { attrs: { "data-level": "1" } }, [_vm._v("5. Appendix")]),
        _c("div", { attrs: { "data-level": "2" } }, [
          _vm._v(
            "\n      *List of Countries/Regions for This Event (ln No Particular Order)\n    "
          ),
        ]),
        _c(
          "pre",
          {
            staticClass: "ff--common",
            staticStyle: { "white-space": "pre-wrap" },
            attrs: { "data-level": "2" },
          },
          [
            _vm._v(
              "Australia\nPapua New Guinea\nPakistan\nBhutan\nPhilippines\nFiji\nKazakhstan\nKyrgyzstan\nCambodia\nLaos\nMaldives\nMalaysia\nMongolia\nFederated States of Micronesia\nMyanmar\nNauru\nNepal\nPalau\nSri Lanka\nSolomon Islands\nTajikistan\nThailand\nTonga\nTurkmenistan\nVanuatu\nBrunei\nUzbekistan\nSingapore\nNew Zealand\nIndonesia\nCanada\nUnited States\nAlbania\nIreland\nEstonia\nAustria\nBelarus\nBulgaria\nNorth Macedonia\nBelgium\nIceland\nPoland\nBosnia and Herzegovina\nDenmark\nGermany\nRussia\nFrance\nFinland\nNetherlands\nMontenegro\nCzech Republic\nKosovo\nCroatia\nLatvia\nLithuania\nLuxembourg\nRomania\nMalta\nMoldova\nNorway\nPortugal\nSweden\nSwitzerland\nSerbia\nCyprus\nSlovakia\nSlovenia\nTürkiye\nUkraine\nSpain\nGreece\nHungary\nItaly\nUnited Kingdom\nAlgeria\nAfghanistan\nUnited Arab Emirates\nOman\nAzerbaijan\nEgypt\nAngola\nBahrain\nBenin\nBotswana\nBurkina Faso\nCabo Verde\nThe Gambia\nRepublic of the Congo\nDemocratic Republic of the Congo\nGeorgia\nGuinea-Bissau\nGhana\nGabon\nZimbabwe\nCameroon\nQatar\nCôte d'Ivoire\nKuwait\nKenya\nLebanon\nLiberia\nLibya\nRwanda\nMadagascar\nMalawi\nMali\nMauritius\nMauritania\nMorocco\nMozambique\nNamibia\nSouth Africa\nNiger\nNigeria\nSierra Leone\nSenegal\nSeychelles\nSaudi Arabia\nSão Tomé and Príncipe\nEswatini\nTanzania\nTunisia\nUganda\nArmenia\nYemen\nIraq\nIsrael\nIndia\nJordan\nZambia\nChad\nArgentina\nAnguilla\nAntigua and Barbuda\nBarbados\nThe Bahamas\nParaguay\nPanama\nBrazil\nBermuda\nBolivia\nBelize\nDominican Republic\nDominica\nEcuador\nColombia\nCosta Rica\nGrenada\nGuyana\nHonduras\nCayman Islands\nMontserrat\nPeru\nMexico\nNicaragua\nEI Salvador\nSaint Kitts and Nevis\nSaint Lucia\nSaint Vincent and the Grenadines\nSuriname\nTurks and Caicos Islands\nTrinidad and Tobago\nGuatemala\nVenezuela\nUruguay\nJamaica\nBritish Virgin Islands\nChile\n    "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }